/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {TwitterThreadLayout} from "../../layouts/TwitterThreadLayout";
import {TwitterThreadBlock, TwitterThreadAuthor, TwitterThreadOriginalUrl, TwitterThreadBlockFirst} from "../../components/TwitterThread";
export const meta = {
  url: "https://devsforgood.com/thread/designing-platforms-for-developers",
  title: "Designing platforms for developers",
  description: `Designing Platforms for Developers.

Thread🧵`,
  image: "/covers/threads/designing-platforms-for-developers.png",
  author: "codemarch"
};
const MDXLayout = ({children}) => _jsx(TwitterThreadLayout, {
  meta: meta,
  children: children
});
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    a: "a",
    ol: "ol",
    li: "li"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(TwitterThreadAuthor, {
      name: "codemarch",
      username: "codemarch",
      avatarUrl: "/avatars/codemarch.png"
    }), "\n", _jsx(TwitterThreadOriginalUrl, {
      url: "https://twitter.com/codemarch/status/1594910764019900417"
    }), "\n", _jsxs(TwitterThreadBlockFirst, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "Designing Platforms for Developers."
      }), _jsx(_components.p, {
        children: "Thread🧵"
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "📌Visme"
      }), _jsxs(_components.p, {
        children: ["🔗 ", _jsx(_components.a, {
          href: "https://www.visme.co/",
          children: "https://www.visme.co/"
        })]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "📌Figma"
      }), _jsxs(_components.p, {
        children: ["🔗 ", _jsx(_components.a, {
          href: "https://www.figma.com/",
          children: "https://www.figma.com/"
        })]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "📌Snappa"
      }), _jsxs(_components.p, {
        children: ["🔗 ", _jsx(_components.a, {
          href: "https://snappa.com/",
          children: "https://snappa.com/"
        })]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "📌Canva"
      }), _jsxs(_components.p, {
        children: ["🔗 ", _jsx(_components.a, {
          href: "https://www.canva.com/",
          children: "https://www.canva.com/"
        })]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "📌Adobe Spark"
      }), _jsxs(_components.p, {
        children: ["🔗 ", _jsx(_components.a, {
          href: "https://www.adobe.com/express/",
          children: "https://www.adobe.com/express/"
        })]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "📌Crello"
      }), _jsxs(_components.p, {
        children: ["🔗 ", _jsx(_components.a, {
          href: "https://create.vista.com/",
          children: "https://create.vista.com/"
        })]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "📌Stencil"
      }), _jsxs(_components.p, {
        children: ["🔗 ", _jsx(_components.a, {
          href: "https://getstencil.com/",
          children: "https://getstencil.com/"
        })]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "📌PicMonkey"
      }), _jsxs(_components.p, {
        children: ["🔗 ", _jsx(_components.a, {
          href: "https://www.picmonkey.com/",
          children: "https://www.picmonkey.com/"
        })]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "📌Gravit Designer"
      }), _jsxs(_components.p, {
        children: ["🔗 ", _jsx(_components.a, {
          href: "https://www.coreldraw.com/",
          children: "https://www.coreldraw.com/"
        })]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "If you enjoyed reading this thread, please do the following:"
      }), _jsxs(_components.ol, {
        children: ["\n", _jsx(_components.li, {
          children: "Like the thread❤️"
        }), "\n", _jsx(_components.li, {
          children: "Retweet the first tweet.🔃"
        }), "\n", _jsx(_components.li, {
          children: "Follow me and enable notifications: ✅\n@CodeMarch\nThank you for reading all the way through."
        }), "\n"]
      })]
    })]
  });
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
